import { Component, OnInit } from '@angular/core';
import { Document } from 'src/app/shared/data/data.generated';
import { ApiService } from 'src/app/shared/services/api.service';
import { Subject, takeUntil, debounceTime } from 'rxjs';
import { Router } from '@angular/router';
import {
  ColumnDefinitionV3,
  TextFilterV3Component,
  TableServiceV3,
  ColumnRendererComponentV3,
  PageHeaderModule,
  SearchBarV2Module,
  TableV3Component,
  SelectFilterRendererV3,
  SelectFilterV3Component,
  PageContentLayoutComponent,
} from '@gea/digital-ui-lib';
import { RenderCompanyName } from './document-renderers/company-name-renderer.component';
import { RenderFileIcon } from './document-renderers/file-icon-renderer.component';
import { RenderActionButton } from './document-renderers/action-button-renderer.component';
import { Filter } from 'src/app/shared/services/api/table';
import {
  ActiveChipFilters,
  Chip,
  HrtFilterChipsComponent,
} from '../../shared/components/hrt-filter-chips/hrt-filter-chips.component';
import { FormBuilder } from '@angular/forms';
import { UtilityService } from 'src/app/shared/services/utility.service';
@Component({
  selector: 'app-document-library',
  templateUrl: './document-library.component.html',
  styleUrls: ['./document-library.component.scss'],
  standalone: true,
  imports: [
    PageHeaderModule,
    SearchBarV2Module,
    TableV3Component,
    HrtFilterChipsComponent,
    PageContentLayoutComponent,
  ],
})
export class DocumentLibraryComponent implements OnInit {
  constructor(
    private api: ApiService,
    private router: Router,
    private tableService: TableServiceV3,
    private fb: FormBuilder,
    private utilityService: UtilityService,
  ) {}

  public columnDefinitions: ColumnDefinitionV3[] = [
    {
      displayName: 'Title',
      minWidth: 400,
      key: 'Title',
      sortable: true,
      filter: {
        component: TextFilterV3Component,
      },
    },
    {
      displayName: 'Company',
      key: 'CompanyId',
      minWidth: 200,
      sortable: true,
      renderer: {
        component: RenderCompanyName as ColumnRendererComponentV3<any>,
      },
      filter: {
        component: SelectFilterV3Component,
        config: {
          options: [
            { name: 'All', value: '-1' },
            { name: 'GEA York ', value: '0' },
            { name: 'GEA Vancouver', value: '1' },
            { name: 'GEA Vancouver (Aerofreeze)', value: '2' },
            { name: 'GEA France', value: '3' },
            { name: 'GEA Berlin', value: '4' },
            { name: "GEA 's-Hertogenbosch", value: '5' },
            { name: 'Bock', value: '6' },
            { name: 'GEA Suzhou', value: '7' },
            { name: 'GEA EMEA Skids', value: '8' },
            { name: 'GEA Cape Town', value: '9' },
            { name: 'GEA EMEA Skids (Service Sales)', value: '10' },
            { name: "GEA 's-Hertogenbosch (Service Sales)", value: '11' },
            { name: 'None', value: '' },
          ],
        },
      } as SelectFilterRendererV3,
    },
    {
      displayName: 'Product Family',
      key: 'ProductFamily',
      sortable: true,
      filter: {
        component: SelectFilterV3Component,
        config: {
          options: [
            {
              value: 'Automation & Control Systems',
              name: 'Automation & Control Systems',
            },
            { value: 'Brewing Systems', name: 'Brewing Systems' },
            { value: 'Chillers & Heat Pumps', name: 'Chillers & Heat Pumps' },
            { value: 'Compressors', name: 'Compressors' },
            {
              value: 'Dryers & Particle Processing Plants',
              name: 'Dryers & Particle Processing Plants',
            },
            {
              value: 'Food Processing Systems',
              name: 'Food Processing Systems',
            },
            {
              value: 'Freezers Evaporators & Crystallizers',
              name: 'Freezers Evaporators & Crystallizers',
            },
            {
              value: 'Milking & Farming Systems',
              name: 'Milking & Farming Systems',
            },
            { value: 'Valves & Pumps', name: 'Valves & Pumps' },
          ],
        },
      } as SelectFilterRendererV3,
    },
    {
      displayName: 'Language',
      key: 'Language',
      sortable: true,
      minWidth: 200,
      filter: {
        component: SelectFilterV3Component,
        config: {
          options: [
            { name: 'Bulgarian', value: 'Bulgarian' },
            { name: 'Croatian', value: 'Croatian' },
            { name: 'Czech', value: 'Czech' },
            { name: 'Danish', value: 'Danish' },
            { name: 'Dutch', value: 'Dutch' },
            { name: 'English', value: 'English' },
            { name: 'English (GB)', value: 'English (GB)' },
            { name: 'English (US)', value: 'English (US)' },
            { name: 'Estonian', value: 'Estonian' },
            { name: 'Finnish', value: 'Finnish' },
            { name: 'French', value: 'French' },
            { name: 'German', value: 'German' },
            { name: 'Greek', value: 'Greek' },
            { name: 'Hungarian', value: 'Hungarian' },
            { name: 'Italian', value: 'Italian' },
            { name: 'Norwegian', value: 'Norwegian' },
            { name: 'Polish', value: 'Polish' },
            { name: 'Portuguese', value: 'Portuguese' },
            { name: 'Portuguese (BR)', value: 'Portuguese (BR)' },
            { name: 'Portuguese (PT)', value: 'Portuguese (PT)' },
            { name: 'Romanian', value: 'Romanian' },
            { name: 'Russian', value: 'Russian' },
            { name: 'Slovak', value: 'Slovak' },
            { name: 'Spanish (ES)', value: 'Spanish (ES)' },
            { name: 'Swedish', value: 'Swedish' },
            { name: 'Thai', value: 'Thai' },
            { name: 'Turkish', value: 'Turkish' },
          ],
        },
      } as SelectFilterRendererV3,
    },
    {
      displayName: 'Document Type',
      key: 'DocumentType',
      sortable: true,
      filter: {
        component: SelectFilterV3Component,
        config: {
          options: [
            { value: 'Brochure', name: 'Brochure' },
            { value: 'CAD (2D)', name: 'CAD (2D)' },
            { value: 'CAD (3D)', name: 'CAD (3D)' },
            { value: 'Drawing', name: 'Drawing' },
            {
              value: 'Installation Instruction',
              name: 'Installation Instruction',
            },
            { value: 'Lubricants', name: 'Lubricants' },
            {
              value: 'Maintenance Instruction',
              name: 'Maintenance Instruction',
            },
            { value: 'Operating Instruction', name: 'Operating Instruction' },
            { value: 'Parts Manual', name: 'Parts Manual' },
            { value: 'Picture', name: 'Picture' },
            { value: 'Planning guide', name: 'Planning guide' },
            { value: 'Product Information', name: 'Product Information' },
            { value: 'Quick Reference Guide', name: 'Quick Reference Guide' },
            { value: 'Safety Instruction', name: 'Safety Instruction' },
            { value: 'Software', name: 'Software' },
            { value: 'Spare parts list', name: 'Spare parts list' },
            {
              value: 'Transportation instruction',
              name: 'Transportation instruction',
            },
          ],
        },
      } as SelectFilterRendererV3,
    },
    {
      displayName: 'File Type',
      key: 'FileType',
      sortable: false,
      renderer: { component: RenderFileIcon as ColumnRendererComponentV3<any> },
      filter: {
        component: SelectFilterV3Component,
        config: {
          options: [
            { name: 'Document', value: 'Document' },
            { name: 'DWG', value: 'DWG' },
            { name: 'jpeg', value: 'JPEG' },
            { name: 'Layout', value: 'Layout' },
            { name: 'PDF', value: 'PDF' },
            { name: 'STEP', value: 'STEP' },
            { name: 'Video', value: 'Video' },
            { name: 'ZIP', value: 'ZIP' },
            { name: 'ipt', value: 'ipt' },
            { name: 'sat', value: 'sat' },
            { name: 'stp', value: 'stp' },
          ],
        },
      } as SelectFilterRendererV3,
    },
    { displayName: 'Size (MB)', key: 'Size', sortable: true },
    {
      displayName: 'Actions',
      key: 'Actions',
      sortable: false,
      renderer: {
        component: RenderActionButton as ColumnRendererComponentV3<any>,
      },
    },
  ];

  tableId: string = 'hrtc-documents-library';
  searchPlaceholder = 'Search Documents';
  destroy$ = new Subject<void>();
  searchInput = new Subject<string>();
  count: number = 0;
  sortKey?: string;
  sortOrder?: string;
  statusFilters: string[] = [];
  page: number = 0;
  pageSize: number = 10;
  documentsSearch?: string;
  docResponse: Document[] = [];
  isTableLoading: boolean = true;
  filters: Filter = {};
  activeChipFilters: ActiveChipFilters = { searchText: '', filters: {} };
  searchForm = this.fb.group({
    search: [''],
  });

  ngOnInit(): void {
    this.handleHeaderClick();
    this.handleSearchChanged();
  }

  private handleHeaderClick() {
    this.tableService
      .getFilterTableSettings(this.tableId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((settings) => {
        if (!settings?.columns) return;
        if (settings?.columns) {
          this.filters = this.buildBackendFiltersFromColumns(
            settings.columns,
            this.columnDefinitions,
          );
        }
        if (settings?.page !== undefined) {
          this.page = settings.page;
        }
        this.pageSize = settings?.pageSize ?? this.pageSize;
        const sortedColumn = Object.keys(settings.columns).find(
          (key) => settings.columns[key].sort ?? '',
        );

        if (sortedColumn) {
          this.sortKey = sortedColumn;
          if (settings.columns[sortedColumn].sort) {
            this.sortOrder =
              settings.columns[sortedColumn].sort === 'desc' ? 'True' : 'False';
          } else {
            this.sortOrder = '';
          }
        }

        this.activeChipFilters.filters = settings?.columns
          ? settings.columns
          : this.activeChipFilters.filters;

        this.fetchDocuments();
      });
  }

  private handleSearchChanged(): void {
    this.searchInput.pipe(debounceTime(500)).subscribe({
      next: (searchTerm: string) => {
        if (searchTerm.length >= 3 || searchTerm.length == 0) {
          this.documentsSearch = searchTerm;
          this.utilityService.setTableSearchSetting(
            this.tableId,
            this.documentsSearch,
          );
          this.page = 0; // Reset to first page on new table search
          this.fetchDocuments();
        }
      },
    });
  }

  searchValueChanged(newValue: string): void {
    this.searchInput.next(newValue);
  }

  fetchDocuments(): void {
    this.isTableLoading = true;
    if (this.utilityService.getTableSearchSetting(this.tableId)) {
      this.documentsSearch = this.utilityService.getTableSearchSetting(
        this.tableId,
      );
    }
    const listOptions = {
      Search: this.documentsSearch ?? '',
      SortColumn: this.sortKey ?? '',
      SortDesc: this.sortOrder ?? '',
      PageSize: this.pageSize,
      Page: this.page,
      HasPaging: true,
      Filters: this.filters as Filter,
    };
    this.api.Documents.GetDocuments(listOptions).subscribe({
      next: (response: DocumentListResponse) => {
        this.docResponse = response.Data ?? [];
        this.activeChipFilters.searchText = this.documentsSearch ?? '';
        this.count = response.Count;
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        this.isTableLoading = false;
      },
    });
  }

  onChipRemoved(chip: Chip) {
    if (chip && chip.chipKey === 'clearAll') {
      // Clear all filters
      this.activeChipFilters = { searchText: '', filters: {} };
      this.documentsSearch = '';
      this.sortKey = '';
      this.sortOrder = '';
      this.filters = {};
      this.utilityService.setTableSearchSetting(this.tableId, '');
      this.searchForm.get('search')?.setValue('');
      this.tableService.setFilterTableSettings(this.tableId, {
        columns: this.activeChipFilters.filters,
        page: this.page,
        pageSize: this.pageSize,
      });
    } else if (
      chip &&
      chip.chipKey === 'searchText' &&
      chip.chipValue !== '' &&
      this.activeChipFilters.searchText === chip.chipValue
    ) {
      // Clear documents search
      this.documentsSearch = '';
      this.utilityService.setTableSearchSetting(this.tableId, '');
      this.activeChipFilters.searchText = '';
      this.tableService.setFilterTableSettings(this.tableId, {
        columns: this.activeChipFilters.filters,
        page: this.page,
        pageSize: this.pageSize,
      });
      this.searchForm.get('search')?.setValue('');
    } else {
      if (chip && chip.chipKey !== 'searchText' && chip.chipValue !== '') {
        // 1. If chipValue is 'asc' or 'desc', remove "sort chip" and update documents
        if (chip.chipValue === 'asc' || chip.chipValue === 'desc') {
          if (this.activeChipFilters.filters[chip.chipKey]) {
            this.activeChipFilters.filters[chip.chipKey].sort = '';
            this.sortKey = '';
            this.sortOrder = '';
            this.tableService.setFilterTableSettings(this.tableId, {
              columns: this.activeChipFilters.filters,
              page: this.page,
              pageSize: this.pageSize,
            });
            this.fetchDocuments();
          }
        } else {
          // 2. Remove "filter chip" for chipKey with chipValue
          if (
            this.activeChipFilters.filters[chip.chipKey] &&
            Array.isArray(this.activeChipFilters.filters[chip.chipKey].filter)
          ) {
            this.activeChipFilters.filters[chip.chipKey].filter =
              this.activeChipFilters.filters[chip.chipKey].filter.filter(
                (val: any) => val !== chip.chipValue,
              );
            // Rebuild backend filters and update documents
            this.filters = this.buildBackendFiltersFromColumns(
              this.activeChipFilters.filters,
              this.columnDefinitions,
            );
            this.tableService.setFilterTableSettings(this.tableId, {
              columns: this.activeChipFilters.filters,
              page: this.page,
              pageSize: this.pageSize,
            });
            this.fetchDocuments();
          }
        }
      }
    }
  }

  onRowClicked(doc: Document) {
    this.router.navigate(['document-details', { id: doc.Id }]);
  }

  buildBackendFiltersFromColumns(columns: any, columnDefinitions: any[]): any {
    const backendFilters: any = {};

    columnDefinitions.forEach((colDef) => {
      const key = colDef.key;
      const col = columns[key];
      if (
        col &&
        col.filter &&
        Array.isArray(col.filter) &&
        col.filter.length > 0
      ) {
        // Find options for this column if available
        const options = colDef.filter?.config?.options || [];
        const values = col.filter.map((val: any) => {
          // Try to find a matching option for key/label mapping
          const found = options.find(
            (opt: any) =>
              opt.value?.toString() === val?.toString() ||
              opt.key?.toString() === val?.toString() ||
              opt.label === val ||
              opt.name === val,
          );
          return found
            ? {
                key: found.key ?? found.value ?? val,
                label: found.label ?? found.name ?? val,
              }
            : { key: val, label: val };
        });

        backendFilters[key] = {
          isClientSide: false,
          type: 'multiSelect',
          values,
        };
      }
    });

    return backendFilters;
  }

  ngOnDestroy(): void {
    this.tableService.updateFilterTableSettings(this.tableId, {
      columns: this.activeChipFilters.filters,
    });
    this.destroy$.complete();
    this.searchInput.complete();
  }
}
export interface DocumentListResponse {
  Count: number;
  Data: Document[];
}
